import * as React from 'react';
import { observer } from 'mobx-react';
import { OutlinedButton } from 'elc-buttons';
import styled from 'styled-components';
import { ResponsiveModal } from 'elc-responsive-modal';
import * as classnames from 'classnames';
import { FilterIcon } from 'elc-icons';
import { classes } from '../../utils/Classes';

export interface IMobileFiltersModal {
    filtersLabel: string;
    isFiltersModalOpen: boolean;
    onOpenFilters(): void;
    onCloseFilters(): void;
    children: React.ReactNode;
    totalAppliedFilters?: number;
}

const Wrapper = styled.div`
    height: 100%;
`;

const FilterButton = styled(OutlinedButton)`
    width: 100%;
    height: 100%;
`;

export const MobileFiltersModal = observer((props: IMobileFiltersModal) => {
    const {
        filtersLabel,
        isFiltersModalOpen,
        onOpenFilters,
        onCloseFilters,
        children,
        totalAppliedFilters
    } = props;

    const mobileFiltersModalWrapperClassnames = classes('mobile-filters-modal-wrapper');

    const filtersModalButtonClassnames = classes('mobile-filters-modal-button');

    const filtersModalClassnames = classnames(
        'elc-mobile-filters-modal',
        'js-elc-mobile-filters-modal',
        {
            'is-open': isFiltersModalOpen
        }
    );

    return (
        <Wrapper className={mobileFiltersModalWrapperClassnames}>
            <FilterButton className={filtersModalButtonClassnames} onClick={onOpenFilters}>
                {filtersLabel} {totalAppliedFilters ? `(${totalAppliedFilters})` : ''}{' '}
                <FilterIcon />
            </FilterButton>
            <ResponsiveModal
                className={filtersModalClassnames}
                title={filtersLabel}
                isOpen={isFiltersModalOpen}
                deactivateModal={onCloseFilters}
            >
                {children}
            </ResponsiveModal>
        </Wrapper>
    );
});
